import { useTheme } from "@emotion/react";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import DataGridCustomToolbar from "components/DataGridCustomToolBar";
import { fetchOrganisations } from "reduxStore/actions/organisationActions";
import moment from "moment";
import { EditOutlined } from "@mui/icons-material";

function OrgGrid({ handleEditOpen }) {
  const { palette } = useTheme();
  const backgroundAlt = palette.background.alt;
  const primaryLight = palette.primary.light;
  const primaryDark = palette.primary.dark;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("");

  const [searchInput, setSearchInput] = useState("");

  const dispatch = useDispatch();

  const organisations = useSelector((state) => state.organisations.data || []);
  const totalOrgs = useSelector((state) => state.organisations.total || 0);

  useEffect(() => {
    const filters = {
      page,
      pageSize,
      sort,
      search,
    };
    dispatch(fetchOrganisations(filters));
  }, [page, pageSize, sort, search, dispatch]);

  const columns = [
    { field: "name", headerName: "Organisation Name", flex: 1 },
    { field: "description", headerName: "Description", flex: 2 },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      renderCell: (params) => moment(params.value).format("ll"),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 1,
      renderCell: (params) => moment(params.value).format("ll"),
    },
    {
      field: "edit",
      headerName: "Edit",
      flex: 0.5,
      renderCell: (params) => (
        <button
          onClick={() => handleEditOpen(params.row)}
          style={{ backgroundColor: "transparent", border: "none" }}
        >
          <EditOutlined sx={{ color: primaryDark }} />
        </button>
      ),
    },
  ];

  return (
    <Box
      mt="40px"
      sx={{
        "& .MuiDataGrid-root": {},
        "& .MuiDataGrid-cell": {
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflow: "visible",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-footerContainer": {
          backgroundColor: primaryLight,
        },
        "& .MuiDataGrid-row": {
          height: "auto", // This ensures the row height adapts to content
        },
      }}
    >
      <DataGrid
        getRowId={(row) => row._id}
        rows={organisations}
        columns={columns}
        page={page}
        pageSize={pageSize}
        rowCount={totalOrgs}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        onPageChange={(params) => {
          setPage(params);
        }}
        onPageSizeChange={(newPageSize) => {
          setPage(0);
          setPageSize(newPageSize);
        }}
        paginationMode="server"
        components={{
          Toolbar: DataGridCustomToolbar,
        }}
        componentsProps={{
          toolbar: {
            search,
            setSearch,
            searchInput,
            setSearchInput,
            sort,
            setSort,
          },
        }}
        disableSelectionOnClick
        rowHeight={50}
        autoHeight
      />
    </Box>
  );
}

export default OrgGrid;
